import { render, staticRenderFns } from "./layout6.vue?vue&type=template&id=30fb6afc&"
import script from "./layout6.vue?vue&type=script&lang=js&"
export * from "./layout6.vue?vue&type=script&lang=js&"
import style0 from "./layout6.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports